// extracted by mini-css-extract-plugin
module.exports = {"select-types":"index_select-types__kAS_2","typeSelected":"index_typeSelected__jXmZg"};